export default __webpack_public_path__ + "static/media/P1000-sm-close.c2071626.svg";